import React, { useMemo } from 'react';
import { IProduct } from 'src/interfaces';

import { ProductGridContainer } from './EditProductCategoryPage.styled';
import { ProductCard } from './ProductCard';

interface ProductGridProps {
  products: IProduct[];
  assets: any[];
  selectedProducts: IProduct[];
  onProductToggle: (product: IProduct) => void;
}

export const ProductGrid = React.memo(
  ({
    products,
    assets,
    selectedProducts,
    onProductToggle,
  }: ProductGridProps) => {
    const selectedProductCodes = useMemo(
      () => new Set(selectedProducts.map((p) => p.product_code)),
      [selectedProducts],
    );

    return (
      <ProductGridContainer container spacing={1}>
        {products.map((product: IProduct) => (
          <ProductCard
            key={product.product_code}
            product={product}
            assets={assets}
            isSelected={selectedProductCodes.has(product.product_code)}
            onToggle={onProductToggle}
          />
        ))}
      </ProductGridContainer>
    );
  },
);

ProductGrid.displayName = 'ProductGrid';
